import { useQuery } from '@apollo/client';
import logoBzc from 'Assets/images/BzcLogo1.svg';
import { PageContainer } from 'Ui';
import styled from 'styled-components/macro';
import HeaderBasket from '../HeaderBasket';
import {
  getHeaderNavigation,
  getHeaderNavigationVariables,
} from '../__generated__/getHeaderNavigation';
import query from '../headerNavigationQuery';
import { MenuBar } from '../menuComponents';
import AccountMenu from './AccountMenu';
import AnonymousHeader from './AnonymousHeader';

import BannerApp from 'Components/BannerApp';
import { storageFactory } from 'Libs/storageFactory';
import AuthStore from 'Store/AuthStore';
import { theme } from 'Ui';
import { isAndroid, isIOS } from 'react-device-detect';

import { DeviceEnum, OsEnum } from '__generated__/graphql-global-types';
import { isMobile } from 'react-device-detect';

import { HeaderLinks, Link } from 'Ui/Link';

import { purgeVisibility } from 'Libs/Gtm/home';
import UiStore from 'Store/UiStore';
import WishListMenu from './WishListMenu';
import SearchInput from '../MobileHeader/SearchInput';
import { useEffect } from 'react';
import { getCookie } from 'Utils/cookie';
import { getUserType } from 'Utils/memberType';
import { useTranslation } from 'react-i18next';
import { Loop } from 'Ui/Icons/icons';
import { HeaderNavigation } from './HeaderNavigation';

// const DesktopHeaderHeight = 6.5;

// const HeaderStyled = styled.div`
//   background-color: white;
//   z-index: 10001;
//   position: relative;
//   padding-top: ${DesktopHeaderHeight}rem;
//   margin-bottom: 1.2rem;
// `;

const LogoStyled = styled.img`
  width: 100%;
  height: 100%;
`;

export const LogoTitle = styled.div`
  font-family: 'Montserrat' !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 3rem;
  font-weight: 500;
  color: var(--design-logo-color);
  text-transform: uppercase;
  letter-spacing: 0.3rem;
  @media screen and (max-width: 48rem) {
    font-size: 2.4rem;
    letter-spacing: 0.3rem;
  }
`;

export const TopBar = styled.div`
  position: relative;
  display: flex;

  justify-content: space-between;
  height: 6.5rem;
  align-items: center;

  /* box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.1); */
  /* padding-bottom: 12px; */
`;

const FixBar = styled.header`
  position: sticky;
  top: 0;
  left: 0;
  width: 100vw;
  background-color: #fff;
  z-index: 10001;
  box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.1);
  .addShadow {
    box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.1);
  }
`;

export const HeaderOuter = styled.header`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10001;
  padding: 1.6rem 1.6rem 0;
`;

export const HeaderBar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 7.5rem;
  padding: 0 3.2rem;
  background-color: #fff;
  box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.1);
`;

export const CenteredNav = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  height: 100%;
  display: flex;
  align-items: center;
`;

export const HeaderIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 2.4rem;
  height: 7.5rem;
  margin-left: auto;
`;

export const PageHeaderContainer = styled.div`
  max-width: 1301px;
  position: relative;
  margin: 0 auto;
  padding: 0rem 2rem;
  @media screen and (min-width: ${theme.breakpoints.medium}px) {
    padding: 0rem 3rem;
  }
  @media screen and (min-width: ${theme.breakpoints.large}px) {
    padding: 0;
  }
`;

export const SvgLoopSearch = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.3 6.674a4.4 4.4 0 0 1 1.286 3.095 4.47 4.47 0 0 1-1.28 3.12 4.33 4.33 0 0 1-3.067 1.296 4.3 4.3 0 0 1-3.061-1.274A4.42 4.42 0 0 1 5.9 9.804c0-1.17.457-2.285 1.272-3.116A4.3 4.3 0 0 1 10.224 5.4c1.151 0 2.257.457 3.076 1.273m-3.06 8.911c1.53 0 2.99-.627 4.064-1.713a5.87 5.87 0 0 0 1.682-4.106 5.8 5.8 0 0 0-1.697-4.084A5.76 5.76 0 0 0 10.224 4c-1.522 0-2.976.62-4.05 1.705A5.85 5.85 0 0 0 4.5 9.804a5.82 5.82 0 0 0 1.682 4.091 5.7 5.7 0 0 0 4.057 1.69m10.037 3.095a.783.783 0 0 1 0 1.093.767.767 0 0 1-1.088 0L15.3 15.937a.783.783 0 0 1 0-1.094.767.767 0 0 1 1.089 0z"
      clipRule="evenodd"
    />
  </svg>
);

export default () => {
  useEffect(() => {
    const scrollShadow: any = document.getElementById('addShadowJs');
    const detectScroll = (event: any) => {
      const getScroll = event.currentTarget.scrollY;
      if (getScroll > 40) {
        scrollShadow.style.boxShadow = '0px 1px 9px 0px rgba(0, 0, 0, 0.1)';
      } else {
        scrollShadow.style.boxShadow = '0px 1px 9px 0px rgba(0, 0, 0, 0.1)';
      }
    };

    window.addEventListener('scroll', detectScroll);
    return () => {
      window.removeEventListener('scroll', detectScroll);
    };
  });
  const menuDevice: DeviceEnum = isMobile
    ? DeviceEnum.MOBILE
    : DeviceEnum.DESKTOP;
  const loggedIn = AuthStore.useStoreState((state) => state.isLoggedIn);
  const sessionMemberType = AuthStore.useStoreState(
    (state) => state.sessionMemberType
  );
  const cookieMobileAppPopup = UiStore.useStoreState(
    (state) => state.cookieMobileApp
  );
  const localStore = storageFactory(() => localStorage);

  const { data } = useQuery<getHeaderNavigation, getHeaderNavigationVariables>(
    query,
    {
      variables: { device: menuDevice, os: OsEnum.SITE },
    }
  );
  const links = (data && data.headerNavigation && data.headerNavigation) || [];
  // const home = '/accueil/index/' === window.location.pathname;
  // const homeType = 'ACCEUIL';

  const setPathHeaderMenu = UiStore.useStoreActions(
    (action) => action.setPathHeaderMenu
  );
  const setLinkType = UiStore.useStoreActions((action) => action.setLinkType);
  setPathHeaderMenu(links);

  const linksMenu = links.map((link, index) => {
    const urlLink = link.url;
    const linkUrlWithoutSlash = urlLink.slice(0, -1);
    const urlMatch =
      window.location.pathname === linkUrlWithoutSlash
        ? linkUrlWithoutSlash
        : link.url;
    return {
      label: link.label,
      url: urlMatch,
      color: link.color,
      alt: link.alt,
      type: link.type,
      target: link.target,
    };
  });

  const isLoggedIn =
    loggedIn || !!localStore.getItem('isLoggedIn') ? true : false;

  // if (!!localStore.getItem('isLoggedIn') === false) {
  //   return <AnonymousHeader />;
  // } else if (!!localStore.getItem('isLoggedIn') === false && !loggedIn) {
  //   return <AnonymousHeader />;
  // }
  // @ts-ignore
  const { t } = useTranslation('header', { useSuspense: true });
  const InterogationPoint = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 48 48"
      fill="none"
    >
      <circle cx="24" cy="24" r="22" stroke="black" stroke-width="2.5" />
      <path
        d="M20 18.5C20 16.015 21.79 14 24 14C26.21 14 28 16.015 28 18.5C28 20.5 26.8 22.2 25 23L24 23.5V27"
        stroke="black"
        stroke-width="2.5"
        stroke-linecap="round"
      />
      <circle cx="24" cy="31" r="1.5" fill="black" />
    </svg>
  );
  return (
    <>
      {/* {!loggedIn && <AnonymousHeader />} */}

      {/* {isLoggedIn && ( */}
      <>
        <HeaderOuter id="addShadowJs">
          {cookieMobileAppPopup && (isAndroid || isIOS) && (
            <BannerApp android={isAndroid} />
          )}

          <HeaderBar>
            <a href="/">
              <LogoTitle className="fontMontserrat">Bazarchic</LogoTitle>
            </a>

            <CenteredNav>
              <HeaderNavigation />
            </CenteredNav>

            <HeaderIcons>
              {/* Lien contact retiré du header par la maquette BZCFRONT-2255,
                  code conservé le temps de la validation :
              <div>
                <a href={'/contact/'}>
                  <InterogationPoint />
                </a>
              </div>
              */}
              <div>
                <AccountMenu />
              </div>
              <div>
                <WishListMenu />
              </div>
              <div className="iconTextColor">
                <HeaderBasket />
              </div>
            </HeaderIcons>
          </HeaderBar>
        </HeaderOuter>
      </>
      {/* )} */}
    </>
  );
};
